module.exports = __webpack_public_path__ + "static/room2-b89216ad81cd1111a33d98868d839d34.jpg";